import { formatPercentage, type AccessReportSnapshot } from "@/lib/access-report";

export function StatBand({ headline }: { headline: AccessReportSnapshot["headline"] }) {
  const stats = [
    { value: headline.listedSpecialists, label: "Listed specialists" },
    { value: headline.specialties, label: "Specialties" },
    { value: headline.suburbs, label: "Suburbs" },
    { value: formatPercentage(headline.liveCoverage.pct), label: "Live coverage" },
    { value: headline.acceptingNow, label: "Accepting now" },
    {
      value: `${headline.waitReports.received}/${headline.waitReports.usable}`,
      label: "Wait reports received / usable",
    },
  ];

  return (
    <dl className="pb-access-stat-band" aria-label="Headline specialist access statistics">
      {stats.map((stat) => (
        <div key={stat.label}>
          <dt>{stat.label}</dt>
          <dd>{stat.value}</dd>
        </div>
      ))}
    </dl>
  );
}
